import { httpGet } from 'giro-react-toolkit/source/UtilityFunctions/Ajax';

/**
 * The mapbox geocoding service
 */
class MapboxGeocoding {
   /**
    * Get a place latitude/longitude and name based on some options.
    * @param {GeocodingOptions} options - The geocoding options.
    * @param {object} abortController
    * @param callbackFct - callback to send the data once it is retrieved.
    * @returns {Promise} The geocode request promise object.
    */
   geocode(options, abortController, callbackFct) {
      const url = `${reachMap.geocodingOptions.geocode.clientUrl}${options.query}.json`;
      let bbox = null;

      if (options.limitbybounds &&
         options.mapbounds &&
         options.mapbounds.length === 2 &&
         options.mapbounds[0].latitude && options.mapbounds[0].longitude &&
         options.mapbounds[1].latitude && options.mapbounds[1].longitude) {
                              // The mapbox geocoding bounds format is minX,minY,maxX,maxY
         bbox = `${options.mapbounds[0].longitude},${options.mapbounds[0].latitude},${options.mapbounds[1].longitude},${options.mapbounds[1].latitude}`;
      }

      let params = {
         autocomplete: true,
         access_token: reachMap.geocodingOptions.accessToken,
         limit: options.limit,
         country: options.country,
         language: options.language
      };

      if (bbox)
         params.bbox = bbox;

      var signal = abortController ? abortController.signal : null;

      const geocodePromise = httpGet(url, { params, fetchOptions: { signal } });

      geocodePromise.then(response => {
         if (response.ok)
            return (response.json());
         else
            throw new Error('Status code:' + response.statusText + '- Failed to geocode the place - ' + JSON.stringify(options));
      }).then(result => {
         if (!(result && result.features))
            callbackFct([]);

         var data = (result.features.map((place) => {
            return ({
               placeName: place.place_name,
               latitude: place.geometry.coordinates[1],
               longitude: place.geometry.coordinates[0]
            });
         }));

         callbackFct(data);
      }).catch((error) => {
         if (error.name !== 'AbortError') {
            callbackFct([], error);
         }
      });

      return (geocodePromise);
   }
   /**
    * Search a location using the latitude/longitude and some options.
    * @param {GeocodingOptions} options - The geocoding options.
    * @param {object} abortController
    * @param callbackFct - callback to send the data once it is retrieved.
    * @returns {Promise} The reverse request promise object.
    */
   reverse(options, abortController, callbackFct) {
      const url = `${reachMap.geocodingOptions.reverse.clientUrl}${options.longitude},${options.latitude}.json`;

      let params = {
         access_token: reachMap.geocodingOptions.accessToken,
         limit: options.limit,
         country: options.country,
         language: options.language,
         types: options.types
      };

      var signal = abortController ? abortController.signal : null;

      const reversePromise = httpGet(url, { params, fetchOptions: { signal } });

      reversePromise.then(response => {
         if (response.ok)
            return (response.json());
         else
            throw new Error('Status code:' + response.statusText + '- Failed to find the place - ' + JSON.stringify(options));
      }).then(result => {
         if (!(result && result.features))
            callbackFct([]);

         var data = (result.features.map((place) => {
            return ({
               placeName: place.place_name,
               latitude: place.geometry.coordinates[1],
               longitude: place.geometry.coordinates[0]
            });
         }));

         callbackFct(data);
      }).catch((error) => {
         if (error.name !== 'AbortError') {
            callbackFct([], error);
         }
      });

      return (reversePromise);
   }
}

export default MapboxGeocoding;
